import { AxiosError } from 'axios';
import { useRef, useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useCreateDriverPerformance = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const inFlight = useRef(false);

    const setRequestLoading = (value: boolean) => {
        inFlight.current = value;
        setLoading(value);
    };

    const onCreateDriverPerformanceError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while creating driver performance.',
        );
    };

    const onCreateDriverPerformanceSuccess = (callbackFn: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message ?? 'Driver performance created successfully.');
        callbackFn();
    };

    const createDriverPerformance = (data: any, callbackFn: () => void) => {
        if (inFlight.current) return;
        inFlight.current = true;

        const url: HttpConfig = {
            url: `api/v1/reports`,
            method: 'post',
            data,
        };

        request(url, onCreateDriverPerformanceSuccess(callbackFn), setRequestLoading, onCreateDriverPerformanceError);
    };

    return { createDriverPerformance, loading };
};

export default useCreateDriverPerformance;
